import { Component, OnInit } from '@angular/core';
import { CoreService } from '../core/_services/core.services';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppBreadcrumbService } from '../consola/app.breadcrumb.service';
import { AlertasService } from '../core/_services/alerta.service';
import { ConfirmationService, } from 'primeng/api';
import {CalendarModule} from 'primeng/calendar';
import { FormControl, FormGroup, FormBuilder, Validators, Form } from '@angular/forms';


@Component({
  selector: 'app-solicitudes-backend',
  templateUrl: './solicitudes-backend.component.html',
  styleUrls: ['./solicitudes-backend.component.scss']
})
export class SolicitudesBackendComponent implements OnInit {
  
  spinnerRegistros : boolean = true;
  formBuilder: FormBuilder;
  formularioFiltro: FormGroup;
  
  listaRegistros : any = [];
  listaMetodos : any = [];
  columnas: any = [];
  totalRecords = 0;

  fechaMaxima : any;
  fechaMinima : any;

  constructor(
    public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public msj: AlertasService,
    public confirmationService: ConfirmationService,
    private breadCrumbService: AppBreadcrumbService
  ) {
    this.breadCrumbService.setItems([
      { label: 'Solicitudes Backend' }
    ]);
   }

  ngOnInit(): void {
    
    this.columnas = [
      { field: 'url', header: 'Url' },
      { field: 'metodo', header: 'Método' },
      { field: 'fecha_solicitud', header: 'Fecha Solicitud' },
      { field: 'cantidad_solicitudes', header: 'Cantidad' },
    ];
    this.fechaMaxima = new Date();
    
    this.formularioFiltro = new FormGroup({
      metodo: new FormControl(),
      fechaInicial: new FormControl(),
      fechaFinal: new FormControl(),
    });
   
    this.cargarDatos();
    this.listarMetodos();
  }
  
  cargarDatos(){
    this.spinnerRegistros = true;
    this.coreService.get('/cargar-registros-log').subscribe(
      (res: any) => {
        this.listaRegistros = res;
        this.totalRecords = this.listaRegistros.length;
        this.spinnerRegistros = false;
        console.log(res);
      },
      (err: any) => {
        this.spinnerRegistros = false;
        console.log(err);
      }
    )
  }

  filtrar(){
    this.spinnerRegistros = true;
    let metod = '';
    let fechaIni = '';
    let fechaFin = '';
    
    if(this.formularioFiltro.value.metodo != undefined){
      metod = this.formularioFiltro.value.metodo.metodo;
    }
    if(this.formularioFiltro.value.fechaInicial != null){
      let date = new Date(this.formularioFiltro.value.fechaInicial);
      let mes = date.getMonth()+1;
      let dia = '';
      if(date.getDate() < 10){
        dia = '0'+date.getDate();
      }else{
        dia = date.getDate().toString();
      }
      fechaIni = dia+'/'+mes+'/'+date.getFullYear().toString().substr(2,2);
     
    }
    if(this.formularioFiltro.value.fechaFinal != null){
      let date = this.formularioFiltro.value.fechaFinal;
      let mes = date.getMonth()+1;
      let dia = '';
      if(date.getDate() < 10){
        dia = '0'+date.getDate();
      }else{
        dia = date.getDate().toString();
      }
      fechaFin = dia+'/'+mes+'/'+date.getFullYear().toString().substr(2,2);
    }
    
    let params = {
      fechaInicial: fechaIni,
      fechaFinal: fechaFin,
      metodo: metod
    };

    
    this.coreService.getWithParams('/cargar-registros-log', params).subscribe(
      (res: any) => {
        this.listaRegistros = res;
        this.totalRecords = this.listaRegistros.length;
        this.spinnerRegistros = false;
       console.log(res);
      },
      (err: any) => {
        this.spinnerRegistros = false;
        console.log(err);
      }
    )
    
  }

  leerArchivo() {
  
    this.coreService.post('/leer-archivo-log', '').subscribe(
      (res: any) => {
        console.log(res);
      },
      (err: any) => {
      }
    )
  }

  listarMetodos(){
    this.coreService.get('/listar-metodos-log').subscribe(
      (res: any) => {
        this.listaMetodos = res;
      },
      (err: any) => {
      }
    )
  }

  actualizarFecha(ev){
    
    this.fechaMinima = this.formularioFiltro.value.fechaInicial;
  }

  exportar(){
    let params = {
      listaRegistros: this.listaRegistros
    }
    this.coreService.downloadWithParams('/exportar-solicitudes-backend', params).subscribe(
      (res: any) => {
        if(res.body.type != 'application/json'){
          let blob = new Blob([res.body], { type: res.headers.get('Content-Type') });
          let file = new File([blob], 'prueba.xlsx', { type: res.headers.get('Content-Type'), lastModified: Date.now() });
          var fileURL = URL.createObjectURL(file);
          //window.open(fileURL);
          var today = new Date();
          var dd = today.getDate();
          var mm = today.getMonth() + 1; //January is 0!
          var yyyy = today.getFullYear();
          var hora = today.getHours();
          var minutos = today.getMinutes();
          let titulo = 'CONSULTAS_BACKEND';
          
          var linkToFile = document.createElement('a');
          linkToFile.download = titulo+'_D_'+dd+'-'+mm+'-'+yyyy+'H_'+hora+'-'+minutos+'.xlsx';
          linkToFile.href = fileURL;
          linkToFile.click();
          this.msj.info("Resumen exportado exitosamente");
        } else {
          this.msj.error("El archivo no se encontró");
        }
      },
      (err: any) => {
        this.msj.error("No es posible exportar el reporte");
      }
    );

  }
}
